import React from 'react';
import './Steps.scss';

const Steps = ({ steps = [], title = 'Te facilitamos el proceso', subtitle}) => {
  return (
    <div className="next-steps">
      {/* <h4>Lorem ipsum dolor sit amet</h4> */}
      {/* <p>Uno de nuestros agentes de ventas estará pronto en contacto y te dará detalles acerca de avalúo de tu vehículo. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.</p> */}
      <h5>{title}</h5>
      {subtitle && <span class="subtitle">{subtitle}</span>}
      <div className="next-steps-all">
        {steps.map(step => (
          <div className="step" key={step.id}>
            <div className="step-image">
              <div className="step-image-inner">
                <img src={step.image} alt=""/>  
              </div>              
            </div>
            <div className="step-info">
              <h6>{step.title}</h6>
              <p>{step.desc}</p>
              {step.button}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default Steps;